<script>
import chart from '@/mixins/chart'

export default {
  mixins: [chart],
  name: 'ChartTargetedStakeholders',
  computed: {
    stakeholdersByCategory () {
      return this.$options.tsv
    }
  }
}
</script>

<template>
  <div class="chart-targeted-stakeholders p-4">
    <h4 class="text-uppercase">
      {{ chartRoute.title }}
    </h4>
    <p>In 2014, as Uber sought to expand their business in Europe, Africa and the Middle East, an advisory firm helped the company compile lists of more than 1,850 “stakeholders” from different sectors it hoped to influence in 29 countries as well as representatives of European Union institutions, leaked documents show.</p>
    <stacked-bar-chart
      class="mb-3"
      label-above
      hide-legend
      :fixed-height="fixedHeight"
      :social-mode="socialMode"
      :data="stakeholdersByCategory" />
    <p class="text-right small mb-0">
      *Officers, executives or board members at think tanks, consumer groups, interest groups and trade groups
    </p>
    <p class="text-muted text-right small mb-0">
      Source: The Uber Files
    </p>
  </div>
</template>

<style lang="scss" scoped>
@import '../../variables.scss';

.chart-targeted-stakeholders {
  overflow: hidden;
  min-height: 500px;
  height: 100%;
  width: 100%;
  position: relative;
  background: white no-repeat center center;
  display: flex;
  flex-direction: column;

  h4 {
    font-family: $jumbotron-font-family;
  }

  .chart--social-mode & {
    background-color: $dark;
  }

  .chart--active-route-view & {
    height: calc(100vh - var(--app-footer-height, 0));
  }
}
</style>

<tsv>
label	value
Politician	758
Public official	590
Executive or board member*	236
Officer*	91
Journalist or media person	64
Business (executive)	62
Academic	42
Business (officer)	26
</tsv>
